import React from 'react';
import './Country.css';

const Country = (props) => {
    // console.log(props.country);
    const { name, capital, population, continents, flags } = props.country;
    return (
        <div className="country">
            <h2>{name.common}</h2>
            <h3>Capital: {capital}</h3>
            <h4>Population: {population}</h4>
            <h5>Continent: {continents}</h5>
            <img src={flags.png} alt="Flag" />
        </div>
    );
};

export default Country;

